export default "__VITE_ASSET__DZRZyebx__"